import type { RouteObject } from 'react-router-dom';

type RouteObjectWithChildren = RouteObject & {
  children?: RouteObject[];
};

export function withDefaultHydrateFallback(routes: RouteObject[]): RouteObject[] {
  return routes.map((route): RouteObject => {
    const routeWithChildren = route as RouteObjectWithChildren;
    const routeWithFallback = {
      ...route,
      hydrateFallbackElement: route.hydrateFallbackElement ?? null,
    };

    if (routeWithChildren.children) {
      return {
        ...routeWithFallback,
        children: withDefaultHydrateFallback(routeWithChildren.children),
      } as RouteObject;
    }

    return routeWithFallback as RouteObject;
  });
}
